import React from 'react';
import { useTranslation } from 'react-i18next';

import CommonPopper from '../common-popper/CommonPopper';
import LanguageMenu from './LanguageMenu';

import './LocalizationDropdown.scss';

const LocalizationDropdown = ({ placement }) => {
  const {
    i18n: { language },
  } = useTranslation();

  return (
    <div className='localization-dropdown'>
      <CommonPopper placement={placement || 'top'} component={LanguageMenu} disablePortal>
        <span className='localization-dropdown_button'>{language}</span>
      </CommonPopper>
    </div>
  );
};

export default LocalizationDropdown;
